import { render, staticRenderFns } from "./UnitStatusChangeInput.vue?vue&type=template&id=5c48828e&"
import script from "./UnitStatusChangeInput.vue?vue&type=script&lang=js&"
export * from "./UnitStatusChangeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports